/**
 * API Configuration
 * Uses environment variables to switch between local and production
 */

// Determine API base URL based on environment
// Use custom flag to override default NODE_ENV behavior in dev mode
const useProductionAPI = process.env.REACT_APP_USE_PRODUCTION_API === 'true';
const isDevelopment = process.env.NODE_ENV === 'development' && !useProductionAPI;
const API_BASE_URL = isDevelopment
  ? process.env.REACT_APP_LOCAL_API_URL
  : process.env.REACT_APP_PRODUCTION_API_URL;

console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
console.log('🔌 API Configuration');
console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
console.log(`📡 API Mode: ${isDevelopment ? '🏠 LOCAL' : '🌐 PRODUCTION'}`);
console.log(`🎯 Target URL: ${API_BASE_URL}`);
console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');

// Warn if configuration seems wrong
if (process.env.NODE_ENV === 'development' && !useProductionAPI && !process.env.REACT_APP_LOCAL_API_URL) {
  console.error('⚠️  WARNING: Running in development mode but LOCAL_API_URL is not set!');
}
if (useProductionAPI && !process.env.REACT_APP_PRODUCTION_API_URL) {
  console.error('⚠️  WARNING: Production API requested but PRODUCTION_API_URL is not set!');
}

// JWT Authentication Endpoints (API Gateway v2)
exports.authLogin = `${API_BASE_URL}/auth/login`;
exports.authRegister = `${API_BASE_URL}/auth/register`;

// Gallery/Collection Endpoints
exports.cohortCollections = `${API_BASE_URL}/thedeep/cohort/collections`;
exports.tourneyCollections = `${API_BASE_URL}/thedeep/tourney/collections`;
exports.generalCollections = `${API_BASE_URL}/thedeep/general/collections`;

// Image Endpoints
exports.cohortImages = `${API_BASE_URL}/thedeep/cohort/images`;
exports.cohortImage = `${API_BASE_URL}/thedeep/cohort/image`;
exports.tourneyImages = `${API_BASE_URL}/thedeep/tourney/images`;
exports.tourneyImage = `${API_BASE_URL}/thedeep/tourney/image`;
exports.generalImages = `${API_BASE_URL}/thedeep/general/images`;
exports.generalImage = `${API_BASE_URL}/thedeep/general/image`;

// Events and Registration Endpoints
exports.events = `${API_BASE_URL}/thedeep/events`;
exports.unprocessedregistrations = `${API_BASE_URL}/thedeep/events/registrations/unprocessed`;
exports.register = `${API_BASE_URL}/thedeep/register`;
exports.registerlistevents = `${API_BASE_URL}/thedeep/register/listevents`;
exports.registerreadevent = `${API_BASE_URL}/thedeep/register/readevent`;
exports.processedregistrations = `${API_BASE_URL}/thedeep/events/registrations`;
exports.processedregistration = `${API_BASE_URL}/thedeep/events/registration`;

// Questions Endpoint
exports.questions = `${API_BASE_URL}/thedeep/questions`;
exports.questionscombined = `${API_BASE_URL}/thedeep/questions/combined`;

// Athletes Endpoint
exports.athletes = `${API_BASE_URL}/thedeep/athletes`;

// Users Endpoint (Admin only)
exports.users = `${API_BASE_URL}/users`;

// Email and Calendar Endpoints
exports.sendmail = `${API_BASE_URL}/thedeep/email`;
exports.calendar = `${API_BASE_URL}/thedeep/calendar`;

// Waiver Endpoints (Admin)
exports.waivers = `${API_BASE_URL}/thedeep/waivers`;
exports.waiversubmissions = `${API_BASE_URL}/thedeep/waiversubmissions`;

// Waiver Public Submission Endpoints
exports.waiversubmit = `${API_BASE_URL}/thedeep/waiversubmit`;
exports.waiversubmitAvailable = `${API_BASE_URL}/thedeep/waiversubmit/available`;

// API Keys and Configuration
exports.apiKey = "9d61a8fc-3376-4234-ae3e-c194d7d4bd34";
exports.email = "thedeepvbc@gmail.com";

//Keys and IDs for Google Calendar owned by eayardworkschedule@gmail.com
exports.apiKeyGoogleCalendar = "AIzaSyCQ87AtU_SXgr5KeGibEfVt7C7wseK1il4";
exports.calendarTheDeep = "thedeepvbc@gmail.com";
exports.calendarBirthdays = "#contacts@group.v.calendar.google.com";
exports.calendarPractice = "7fmt4p1kgg8i77n7h3e0nk3pbo@group.calendar.google.com";
exports.calendarTourney = "u69fddm09nfa6a8cam0gl4rjuc@group.calendar.google.com";
exports.calendarDropin = "nms6dsmks9kk478elpcgojb2j4@group.calendar.google.com";

/*
exports.getUserSalt = 'http://localhost:3002/api/v1/Consent/getUserSalt';
exports.loginKioskUser = 'http://localhost:3002/api/v1/Consent/loginkioskuser';
exports.getKioskUserSalt = 'http://localhost:3002/api/v1/Consent/getkioskusersalt';
exports.tenants = 'http://localhost:3002/api/v1/Consent/tenants';
exports.artists = 'http://localhost:3002/api/v1/Consent/tenants/artists';
exports.artist = 'http://localhost:3002/api/v1/Consent/tenants/artist';
exports.clauses = 'http://localhost:3002/api/v1/Consent/tenants/clauses';
exports.clause = 'http://localhost:3002/api/v1/Consent/tenants/clause';
exports.consents = 'http://localhost:3002/api/v1/Consent/tenants/consents';
exports.consent = 'http://localhost:3002/api/v1/Consent/tenants/consent';
exports.kioskusers = 'http://localhost:3002/api/v1/Consent/tenants/kioskusers';
exports.kioskuser = 'http://localhost:3002/api/v1/Consent/tenants/kioskuser';
exports.includedartists = 'http://localhost:3002/api/v1/Consent/tenants/consent/artists';
exports.includedartistscombined = 'http://localhost:3002/api/v1/Consent/tenants/consent/artists/combined';
exports.includedartist = 'http://localhost:3002/api/v1/Consent/tenants/consent/artist';
exports.includedclauses = 'http://localhost:3002/api/v1/Consent/tenants/consent/clauses';
exports.includedclausescombined = 'http://localhost:3002/api/v1/Consent/tenants/consent/clauses/combined';
exports.includedclause = 'http://localhost:3002/api/v1/Consent/tenants/consent/clause';
exports.submissions = 'http://localhost:3002/api/v1/Consent/submissions';
exports.submission = 'http://localhost:3002/api/v1/Consent/submissions/submission';
exports.register = 'http://localhost:3002/api/v1/Consent/register';
exports.subscriptions = 'http://localhost:3002/api/v1/Consent/subscriptions';
exports.subscription = 'http://localhost:3002/api/v1/Consent/subscriptions/subscription';
*/
//exports.sendmail = 'http://localhost:8084/api/v1/thedeep/sendmail';
//exports.sendmail = 'http://www.thedeepvbc.com/api/v1/thedeep/sendmail';

//General API key for accessing server side REST calls via apigateway
//General API key for accessing server side REST calls via apigateway
//exports.apiKey = "9d61a8fc-3376-4234-ae3e-c194d7d4bd34";
//exports.email = "thedeepvbc@gmail.com";

